import React from "react";
import { MenuItem, Select } from "@mui/material";

/** @typedef {import("api/typesDef").Client} Client */

/**
 * @component
 * @description Reusable component for client selection dropdown used across clinician dashboard modules
 * @param {Object} props
 * @param {Client[]} props.clients - The list of clients
 * @param {Client | "all"} props.selectedClient - The currently selected client
 * @param {function} props.onClientChange - The function to handle client selection changes
 * @param {Object} props.sx - Additional styles for the Select component (optional)
 * @param {Object} rest - Additional props to pass to the Select component
 * @returns {JSX.Element} Client selection dropdown
 */
const ClientSelect = ({ clients, selectedClient, onClientChange, sx = {}, ...rest }) => {
  const defaultSx = {
    width: "100%",
    minWidth: 124,
    ...sx,
  };

  return (
    <Select
      sx={defaultSx}
      value={selectedClient}
      onChange={(e) => onClientChange(e.target.value)}
      data-value={selectedClient}
      {...rest}
    >
      <MenuItem data-testid="client-select-all" value="all">
        All Clients
      </MenuItem>
      {clients?.map((client) => (
        <MenuItem key={client.id} value={client}>
          {client.name} {client.child_last_name}
        </MenuItem>
      ))}
    </Select>
  );
};

export default ClientSelect;
